import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
    SquaresFour, Flask, Atom, NotePencil, FilePdf,
    Heartbeat, Pulse, SignOut, BookOpenText, UsersThree, UserCircle, CalendarBlank, MagnifyingGlass,
} from "@phosphor-icons/react";

const items = [
    { to: "/", label: "Dashboard", icon: SquaresFour, end: true },
    { to: "/compuestos", label: "Principios activos", icon: Atom },
    { to: "/formulas/nuevo", label: "Generar fórmula", icon: Flask },
    { to: "/formulas", label: "Fórmulas", icon: NotePencil },
    { to: "/cronogramas", label: "Cronogramas", icon: CalendarBlank },
    { to: "/analizador", label: "Analizador de productos", icon: MagnifyingGlass },
    { to: "/pacientes", label: "Pacientes", icon: UsersThree },
    { to: "/portfolio", label: "Portfolio", icon: BookOpenText },
    { to: "/tratamientos", label: "Tratamientos estéticos", icon: Heartbeat },
    { to: "/corpus", label: "Corpus científico", icon: Pulse },
];

export default function Layout() {
    const { user, logout } = useAuth();
    return (
        <div className="min-h-screen flex" data-testid="app-layout">
            <aside className="w-64 border-r hairline bg-[var(--bone)] sticky top-0 h-screen flex flex-col" data-testid="sidebar">
                <div className="px-5 py-6 border-b hairline">
                    <Link to="/" className="block" data-testid="brand-link">
                        <div className="label-eyebrow mb-1">Dr. Daniel Quirós</div>
                        <h1 className="font-display text-2xl leading-none tracking-tight">Suplementos<span className="text-[var(--sage)]">.</span></h1>
                        <div className="text-[11px] text-[var(--ink-3)] mt-1 mono">basado en evidencia · ed. quincenal</div>
                    </Link>
                </div>
                <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
                    {items.map((it) => (
                        <NavLink
                            key={it.to}
                            to={it.to}
                            end={it.end}
                            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
                            data-testid={`nav-${it.to.replace(/\//g, "-").replace(/^-/, "") || "home"}`}
                        >
                            <it.icon size={18} className="icon" weight="duotone" />
                            <span>{it.label}</span>
                        </NavLink>
                    ))}
                </nav>
                <div className="p-3 border-t hairline">
                    <NavLink to="/cuenta" className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`} data-testid="nav-cuenta">
                        <UserCircle size={18} className="icon" weight="duotone" />
                        <span>Mi cuenta</span>
                    </NavLink>
                    <div className="px-3 py-2">
                        <div className="text-[11px] text-[var(--ink-3)] mono">conectado</div>
                        <div className="text-sm font-medium truncate" data-testid="user-email">{user?.email}</div>
                    </div>
                    <button
                        onClick={logout}
                        className="nav-item w-full text-left"
                        data-testid="logout-button"
                    >
                        <SignOut size={18} className="icon" />
                        <span>Cerrar sesión</span>
                    </button>
                </div>
            </aside>

            <main className="flex-1 min-w-0 relative">
                <Outlet />
            </main>
        </div>
    );
}
